import React, { useEffect, useState } from 'react';
import { toast } from 'sonner';
import { Briefcase } from 'lucide-react';
import { Card, CardContent } from '@/components/ui/card';
import { AdminLayout, useAdminApi } from '@/components/AdminLayout';

export default function AdminCAsPage() {
  const api = useAdminApi();
  const [firms, setFirms] = useState(null);

  useEffect(() => {
    if (!api) return;
    api.get('/cas').then((r) => setFirms(r.data)).catch(() => { setFirms([]); toast.error('Failed to load CA firms'); });
  }, [api]);

  return (
    <AdminLayout>
      <div data-testid="admin-cas-page">
        <h1 className="text-2xl font-bold font-['Outfit']">CA partner firms</h1>
        <p className="text-gray-400" data-testid="admin-cas-total">{firms?.length || 0} firms registered</p>
      </div>
      <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
        {(firms || []).map((f) => (
          <Card key={f.id} className="bg-[#0a1a12] border-white/10" data-testid={`admin-ca-card-${f.id}`}>
            <CardContent className="pt-6 space-y-3">
              <div className="flex items-center gap-3">
                <div className="w-10 h-10 rounded-lg bg-[#1D9E75]/20 flex items-center justify-center">
                  <Briefcase className="w-5 h-5 text-[#1D9E75]" />
                </div>
                <div className="min-w-0">
                  <p className="font-semibold text-white truncate">{f.name}</p>
                  <p className="text-xs text-gray-500">ICAI: {f.membership_number || '-'}</p>
                </div>
              </div>
              <div className="flex justify-between text-sm">
                <span className="text-gray-400">{f.ca_user?.name || '-'} · {f.ca_user?.email || ''}</span>
                <span className="font-mono text-[#EF9F27]">{f.client_count} clients</span>
              </div>
            </CardContent>
          </Card>
        ))}
        {firms && firms.length === 0 && <p className="text-gray-500">No CA firms yet.</p>}
      </div>
    </AdminLayout>
  );
}
